import { RADashboardLayout } from "@/interfaces/raDashboard.interface"
import { RADashboardPortfolioType } from "../asset-enums"
import { RADashboardTabId } from "../tab-enums"
import DefaultMasterDashboardLayout from "./defaultMaster"

export const DefaultDashboardMultiAsset: RADashboardLayout = {
  ...DefaultMasterDashboardLayout,
  suggestedPortfolioType: [RADashboardPortfolioType.MultiAsset],
  initialTab: RADashboardTabId.Overview,
  tabLayouts: {
    ...DefaultMasterDashboardLayout.tabLayouts
  }
}

export default DefaultDashboardMultiAsset;